import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=5fb2a2cc&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=ts&"
export * from "./Orders.vue?vue&type=script&lang=ts&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=5fb2a2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb2a2cc",
  null
  
)

export default component.exports